import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import GolfIconLight from '../../images/beauforest.com_logo_light.png'
import GolfIconDark from '../../images/beauforest.com_logo_dark.png'
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavItem,
  NavLinks,
  NavLogo,
  NavIcon,
  NavMenu,
  NavBtn,
  NavBtnLink,
  NavBtnExternalLink
} from './NavbarElements';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ toggle, darkMode }) => {
  const history = useNavigate()
  const [scrollnav, setScrollnav] = useState(false);
  const [defaultTextColor, setDefaultTextColor] = useState("#fff")
  const [topBackground, setTopBackground] = useState("transparent")

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollnav(true);
    } else {
      setScrollnav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
    if (darkMode) {
      setDefaultTextColor("#000")
      setTopBackground("rgb(50,50,50,0.5)")
    }
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  const goHome = () => {
    history("/")
  }

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav style = {{ 
            background: scrollnav ? 'rgb(50,50,50,0.9)' : topBackground }} >
          <NavbarContainer>
            {/* <NavLogo onClick={toggleHome} to='/'>
              tumble
            </NavLogo> */}
            {darkMode ?
              <NavIcon src={GolfIconDark} onClick={goHome} /> :
              <NavIcon src={GolfIconLight} onClick={goHome} />
            }
            
            <MobileIcon onClick={toggle}>
              <FaBars color={scrollnav ? "#fff" : defaultTextColor} />
            </MobileIcon>
            <NavMenu>
              <NavItem>
                <NavLinks
                  to='/'
                  smooth='true'
                  duration={500}
                  spy='true'
                  exact='true'
                  offset={-80}
                  style={{ color: scrollnav ? '#fff' : defaultTextColor }}
                >
                  Home
                </NavLinks>
              </NavItem>
              {/* <NavItem>
                <NavLinks
                  to='/tournaments'
                  smooth='true'
                  duration={500}
                  spy='true'
                  exact='true'
                  offset={-80}
                  style={{ color: scrollnav ? '#fff' : defaultTextColor }}
                >
                  Tournaments
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='/associations'
                  smooth='true'
                  duration={500}
                  spy='true'
                  exact='true'
                  offset={-80}
                  style={{ color: scrollnav ? '#fff' : defaultTextColor }}
                >
                  Associations
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='/news'
                  smooth='true'
                  duration={500}
                  spy='true'
                  exact='true'
                  offset={-80}
                  style={{ color: scrollnav ? '#fff' : defaultTextColor }}
                >
                  News
                </NavLinks>
              </NavItem> */}
            </NavMenu>
            {/* <NavBtn>
              <NavBtnExternalLink href='https://app.tumbledelivery.com/'>Login</NavBtnExternalLink>
            </NavBtn> */}
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;